import Tab from "../lds/tabs/Tab";
import TabAnchor from "../lds/tabs/TabAnchor";
import TabGroup from "../lds/tabs/TabGroup";

export default function ViewFeedTabs({
  selectedTab,
  feed,
  hasNewcomers,
  showNewcomers,
  showEdit,
  allowClone
}) {

  const clickNewcomers = (event) => {
    event.preventDefault();
    trackNewcomersClick("View Newcomers", `/feeds/${feed.id}/new_companies`, feed.id);
  }

  const cloneButtonStyles = {
    marginLeft: "var(--space-large)"
  }

  return (
    <TabGroup className="align-center" selectedTab={selectedTab} animated={false}>

      <TabAnchor
        key="feed"
        className="nowrap"
        href={feed.hasEntity ? "ent_feed" : `/feeds/${feed.id}`}
        label={feed.hasEntity ? `Activity involving ${feed.name}` : "Feed"}
        value="feed"
        leadingIcon="feeds"
      />

      { showNewcomers &&
        <TabAnchor
          className="nowrap"
          key="new_companies"
          href={null}
          label={`Newcomers${ hasNewcomers ? " *" : ""}`}
          value="new_companies"
          leadingIcon="newcomer"
          onTabClicked={clickNewcomers}
        />
      }

      <TabAnchor
        className="nowrap"
        key="flagged_events"
        href={feed.hasSavedFeed ? `/feeds/${feed.id}/flagged_events` : "flagged_events"}
        label={`Flagged Events${ feed.hasEntity ? ` with ${feed.name}` : ""}`}
        value="flagged_events"
        leadingIcon="flag"
      />

      { showEdit &&
        <TabAnchor
          className="nowrap"
          key="edit_feed"
          id="feed-edit-tab-btn"
          href={`/feeds/${feed.id}/edit`}
          label="Edit Feed"
          value="edit"
          leadingIcon="edit"
        />
      }

      <h3 id="feed_title" title={feed.name} data-rspec-feed-id={feed.userFeedMonitorId}>
        {feed.name}
      </h3>
      {
        allowClone && <button title="Create a copy of this feed and add it to the feeds you follow" className="button-small button-primary rspec_clone_this_feed"  style={cloneButtonStyles} onClick={() => feed_action('clone',feed.id,'new cloned feed')}>Copy this feed</button>
      }
    </TabGroup>
  );
}

window.ViewFeedTabs = ViewFeedTabs;
